import axios from './axios';

const instance = {
    post(api, params, options = {}) {
        return new Promise((resolve, reject) => {
            axios.post(api, params, options).then((response) => {
                resolve(response);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    get(api, params, options = {}) {
        return new Promise((resolve, reject) => {
            if (params) {
                // eslint-disable-next-line no-param-reassign
                options.params = params;
            }

            axios.get(api, options).then((response) => {
                resolve(response);
            }).catch((err) => {
                reject(err);
            });
        });
    }
};

export default instance;



// WEBPACK FOOTER //
// ./src/util/http/index.js